module.exports = __webpack_public_path__ + "img/31.0f080ab7.jpg";